<div class="workflow-recipe-dialog-plugin" hive-root>
    <div class="workflow-recipe-dialog-plugin__title-section">
        <!-- The per-signal title, not the card's fixed "Workflow Orchestration" header —
             this is what tells the user why the card appeared. -->
        <h6 class="workflow-recipe-dialog-plugin__title hive-header-semibold">{{ renderInfo().signalTitle }}</h6>
    </div>

    <div class="workflow-recipe-dialog-plugin__body">
        <ul class="workflow-recipe-dialog-plugin__list">
            @for (recipe of renderInfo().recipes; track $index) {
                <li class="workflow-recipe-dialog-plugin__recipe">
                    @if (iconsFor(recipe.manifestId); as icons) {
                        @if (icons.length) {
                            <span class="workflow-recipe-dialog-plugin__icons">
                                @for (entry of icons; track entry.label) {
                                    <span class="workflow-recipe-dialog-plugin__icon" [title]="entry.label">
                                        <fa-icon [icon]="entry.icon"></fa-icon>
                                    </span>
                                }
                            </span>
                        }
                    }

                    <span class="workflow-recipe-dialog-plugin__recipe-title">
                        @if (recipe.title) {
                            {{ recipe.title }}
                        } @else {
                            Untitled recipe
                        }
                    </span>

                    @if (recipe.description) {
                        <span class="workflow-recipe-dialog-plugin__recipe-description">{{ recipe.description }}</span>
                    }

                    @if (connectorNamesFor(recipe.manifestId); as connectorNames) {
                        <span class="workflow-recipe-dialog-plugin__recipe-connectors">
                            <hive-label label="Required Connections:" size="small" />
                            <hive-label [label]="connectorNames" size="small" weight="semibold" />
                        </span>
                    }

                    @if (renderInfo().recipes.length > 1) {
                        <span class="workflow-recipe-dialog-plugin__recipe-action">
                            <hive-button
                                label="Import Recipe"
                                emphasis="secondary"
                                size="small"
                                [disabled]="
                                    importDisabled() || !details()[recipe.manifestId] || renderInfo().actionInProgress()
                                "
                                hiveTooltip
                                [hiveTooltipDescription]="importDisabledReason(recipe.manifestId)"
                                (click)="importRecipe(recipe.manifestId)"
                            ></hive-button>
                        </span>
                    }
                </li>
            }
        </ul>
    </div>

    <footer class="workflow-recipe-dialog-plugin__footer">
        @if (renderInfo().allowDismiss) {
            <hive-button
                label="Dismiss Recommendation"
                emphasis="secondary"
                [disabled]="!renderInfo().allowDismiss() || renderInfo().actionInProgress()"
                hiveTooltip
                [hiveTooltipDescription]="renderInfo().allowDismiss() ? '' : 'Operation not permitted'"
                (click)="handleActionEvent(RecommendationActionEvent.DISMISS)"
            ></hive-button>
        }
        <hive-button
            label="Cancel"
            emphasis="secondary"
            [disabled]="renderInfo().actionInProgress()"
            (click)="handleActionEvent(RecommendationActionEvent.CANCEL)"
        ></hive-button>
        <!-- Only when there is one recipe. With several, a single footer button cannot
             say which it would import, so each row carries its own instead. -->
        @if (renderInfo().recipes.length === 1) {
            <hive-button
                label="Import Recipe"
                emphasis="primary"
                [disabled]="
                    importDisabled() ||
                    !details()[renderInfo().recipes[0].manifestId] ||
                    renderInfo().actionInProgress()
                "
                hiveTooltip
                [hiveTooltipDescription]="importDisabledReason(renderInfo().recipes[0].manifestId)"
                (click)="importRecipe(renderInfo().recipes[0].manifestId)"
            ></hive-button>
        }
    </footer>

    <recipe-import-dialog
        (imported)="handleActionEvent(RecommendationActionEvent.RECIPE_IMPORTED)"
    ></recipe-import-dialog>
</div>
